import { getFirebaseBackend } from 'helpers/firebaseHelper';

const loadActivatedAccounts = async (inputValue) => {
  const firebaseHelper = getFirebaseBackend();

  try {
    const accounts = await firebaseHelper.getAllAccounts();

    let select = Object.entries(accounts ?? {})
      ?.filter(([, accountInfo]) => accountInfo.status === true)
      .map(([accountId, accountInfo]) => ({
        value: accountId,
        label: accountInfo.name,
        status: accountInfo.status,
      }));

    select?.sort(({ label: firstLabel }, { label: secondLabel }) => {
      const normalizedA = firstLabel
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
      const normalizedB = secondLabel
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

      return normalizedA > normalizedB ? 1 : normalizedB > normalizedA ? -1 : 0;
    });

    if (inputValue) {
      select = select?.filter(({ label }) => {
        const normalizedOptionLabel = label
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
        const normalizedInput = inputValue
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();

        return normalizedOptionLabel.includes(normalizedInput);
      });
    }

    return select;
  } catch (error) {
    console.error('Error loading activated accounts:', error);
    throw error;
  }
};

export { loadActivatedAccounts };
